<oo-loading-container [status]="state.status">
  <ng-template>
    @if (state.status === 'saving') {
      <oo-overlay-spinner></oo-overlay-spinner>
    }
    <oo-list-header (actionClicked)="openInviteDialog()"
                    [actionText]="state.compGroup.role === 'admin' && !state.tourInfo.tournamentStarted ? 'Invite Friends' : ''"
                    title="Participants">
    </oo-list-header>

    <mat-card appearance="outlined">
      <mat-card-content>
        <mat-list>
          @for (participant of state.participants; track participant.id) {
            <mat-list-item>
              <img
                matListItemAvatar
                [ngSrc]="participant.imageUrl ?? 'https://ui-avatars.com/api/?name=' + participant.firstName + '+' + participant.lastName"
                height="40"
                width="40">
              <span matListItemTitle>{{ participant.firstName }} {{ participant.lastName }}</span>
              <div matListItemMeta class="oo-line-actions">
                @if (participant.role === 'admin') {
                  <mat-chip-listbox>
                    <mat-chip-option [selectable]="false" color="accent">Admin</mat-chip-option>
                  </mat-chip-listbox>
                }
                @if (state.currentUserRole === 'admin') {
                  <button
                    [matMenuTriggerFor]="menu"
                    color="primary"
                    mat-icon-button>
                    <mat-icon>more_vert</mat-icon>
                  </button>
                }
                <mat-menu #menu="matMenu">
                  <button
                    (click)="switchRole(participant.id, participant.role === participantRole.ADMIN ? participantRole.MEMBER : participantRole.ADMIN)"
                    mat-menu-item>
                    <mat-icon>person</mat-icon>
                    <span>Set as {{ participant.role === participantRole.ADMIN ? participantRole.MEMBER : participantRole.ADMIN }}</span>
                  </button>

                  <button (click)="deleteParticipant(participant)" mat-menu-item>
                    <mat-icon>delete</mat-icon>
                    <span>Remove</span>
                  </button>
                </mat-menu>
              </div>
            </mat-list-item>
          }

        </mat-list>
        @if (!state.participants.length) {
          <div>No participant, please create one</div>
        }
      </mat-card-content>
    </mat-card>
  </ng-template>
</oo-loading-container>
